import { useEffect } from 'react';
import { useStackedCardWizardContext } from './stacked-card-wizard-context';

export const useStepData = <T = Record<string, unknown>>(stepId: string) => {
  const { setStepData, getStepData } = useStackedCardWizardContext();

  const updateData = (data: T) => {
    setStepData(stepId, data);
  };

  const getData = (): T => {
    return (getStepData(stepId) || {}) as T;
  };

  const mergeData = (newData: Partial<T>) => {
    const currentData = getData();
    setStepData(stepId, { ...currentData, ...newData });
  };

  // Initialize step data if it doesn't exist
  useEffect(() => {
    const existingData = getStepData(stepId);
    if (!existingData) {
      setStepData(stepId, {});
    }
  }, [stepId, setStepData, getStepData]);

  return {
    updateData,
    getData,
    mergeData,
  };
};
